import React from "react";

function Title() {
  return (
    <section className="title flex-center">
      <h1 id="title">Pomodoro Clock</h1>
    </section>
  );
}

export default Title;
